import css_vrq8elapui from './css/ResizeObserverFrame.css';
import Iframe from './Iframe.js';

const css = css_vrq8elapui;

export default class ResizeObserverFrame extends Iframe
{
	constructor(parentElement)
	{
		super(parentElement);
	}
	get cssText()
	{
		return css;
	}
}